import { useQuery } from '@apollo/react-hooks';
import { createAddressRestObject } from '../createAddressRestObject';
import { RestAddressAttributesData, AddressQueryVariables } from '../fragments.rest';
import { VALIDATE_ADDRESS_QUERY, ValidateAddressQuery } from './useValidateAddressQuery.rest';

export const useValidateAddressQuery = (address: RestAddressAttributesData) => {
  const { data, loading, error } = useQuery<ValidateAddressQuery, AddressQueryVariables>(
    VALIDATE_ADDRESS_QUERY,
    { ...createAddressRestObject(address) }
  );
  return { address: data?.validateAddress.data[0]?.attributes, loading, error };
};
